/** Used for default backgrounds. */
export const fsColorBackgroundWhite = "hsl(0, 0%, 100%)";
/** Transparent for background use */
export const fsColorBackgroundTransparent = "hsla(0, 0%, 0%, 0)";
/** Used for highlighted backgrounds. */
export const fsColorBackgroundHighlight = "hsl(200, 100%, 97%)";
/** Used for primary branded backgrounds. */
export const fsColorBackgroundBrand = "hsl(200, 98%, 18%)";
/** Used for secondary backgrounds. */
export const fsColorBackgroundLight = "hsl(0, 0%, 96%)";
/** Used for dark backgrounds. */
export const fsColorBackgroundDark = "hsl(0, 0%, 8%)";
/** Used for border color on brand background. */
export const fsColorBorderOnBrand = "hsl(204, 32%, 51%)";
/** Used for border color on white background. */
export const fsColorBorderOnWhite = "hsl(0, 0%, 83%)";
/** Used for border color on light background. */
export const fsColorBorderOnLight = "hsl(0, 0%, 66%)";
/** Used for border color on dark background. */
export const fsColorBorderOnDark = "hsl(0, 0%, 100%)";
/** Constant color used for white elements. */
export const fsColorConstantWhite = "hsl(0, 0%, 100%)";
/** Constant color used for black elements. */
export const fsColorConstantBlack = "hsl(0, 0%, 0%)";
/** Constant color used for transparent elements. */
export const fsColorConstantTransparent = "hsla(0, 0%, 0%, 0)";
/** Gravity Neutral Palette (Aligns with Brand G10), Previously: Digital Gray 10 */
export const fsColorDigitalGray5 = "hsl(0, 0%, 96%)";
/** Gravity Neutral Palette */
export const fsColorDigitalGray10 = "hsl(0, 0%, 90%)";
/** Gravity Neutral Palette, Previously: Digital Gray 20 */
export const fsColorDigitalGray15 = "hsl(0, 0%, 83%)";
/** Gravity Neutral Palette */
export const fsColorDigitalGray30 = "hsl(0, 0%, 66%)";
/** Gravity Neutral Palette */
export const fsColorDigitalGray40 = "hsl(0, 0%, 58%)";
/** Gravity Neutral Palette (Aligns with Brand G80), Previously: Digital Gray 80 */
export const fsColorDigitalGray50 = "hsl(0, 0%, 49%)";
/** Gravity Neutral Palette, Previously: Digital Gray 90 */
export const fsColorDigitalGray60 = "hsl(0, 0%, 41%)";
/** Gravity Neutral Palette, Previously: Digital Gray 100 */
export const fsColorDigitalGray70 = "hsl(0, 0%, 32%)";
/** Gravity Neutral Palette, Previously: Digital Gray 110 */
export const fsColorDigitalGray80 = "hsl(0, 0%, 24%)";
/** Gravity Neutral Palette */
export const fsColorDigitalGray95 = "hsl(0, 0%, 12%)";
/** Gravity Neutral Palette (Aligns with Brand C70), Previously: Digital Gray 120 */
export const fsColorDigitalGray100 = "hsl(0, 0%, 8%)";
/** Brand Primary Palette (R179 G205 B222) */
export const fsColorCoreBlue10 = "hsl(204, 39%, 79%)";
/** Brand Primary Palette (R138 G176 B199) */
export const fsColorCoreBlue20 = "hsl(203, 35%, 66%)";
/** Brand Primary Palette (R89 G138 B170) */
export const fsColorCoreBlue30 = "hsl(204, 32%, 51%)";
/** Brand Primary Palette (R37 G95 B130) */
export const fsColorCoreBlue40 = "hsl(203, 56%, 33%)";
/** Brand Primary Palette (R1 G61 B91) */
export const fsColorCoreBlue50 = "hsl(200, 98%, 18%)";
/** Brand Primary Palette (R16 G37 B63) */
export const fsColorCoreBlue60 = "hsl(213, 59%, 15%)";
/** Brand Primary Palette (R0 G19 B43) */
export const fsColorCoreBlue70 = "hsl(213, 100%, 8%)";
/** Tint of base color used for interactive elements. */
export const fsColorInteractionBlue5 = "hsl(200, 100%, 97%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue10 = "hsl(200, 100%, 94%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue20 = "hsl(200, 98%, 75%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue30 = "hsl(200, 98%, 61%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue40 = "hsl(200, 98%, 42%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue50 = "hsl(200, 98%, 35%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue60 = "hsl(200, 97%, 30%)";
/** Gravity Interaction Palette */
export const fsColorInteractionBlue70 = "hsl(200, 98%, 23%)";
/** Tint of base color used for interactive elements. */
export const fsColorInteractionGreen5 = "hsl(108, 100%, 97%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen10 = "hsl(108, 80%, 90%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen20 = "hsl(108, 80%, 75%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen30 = "hsl(108, 64%, 48%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen40 = "hsl(108, 80%, 36%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen50 = "hsl(108, 80%, 28%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen60 = "hsl(108, 81%, 23%)";
/** Gravity Interaction Palette */
export const fsColorInteractionGreen70 = "hsl(108, 80%, 18%)";
/** Tint of base color used for interactive elements. */
export const fsColorInteractionRed5 = "hsl(0, 100%, 97%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed10 = "hsl(358, 100%, 95%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed20 = "hsl(359, 100%, 75%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed30 = "hsl(359, 96%, 65%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed40 = "hsl(359, 88%, 58%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed50 = "hsl(359, 70%, 47%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed60 = "hsl(359, 66%, 44%)";
/** Gravity Interaction Palette */
export const fsColorInteractionRed70 = "hsl(359, 61%, 40%)";
/** Tint of base color used for accent elements. */
export const fsColorAccentYellow5 = "hsl(40, 100%, 97%)";
/** Brand Accent Palette (R255 G241 B208) */
export const fsColorAccentYellow10 = "hsl(42, 100%, 91%)";
/** Brand Accent Palette (R255 G231 B167) */
export const fsColorAccentYellow20 = "hsl(44, 100%, 83%)";
/** Brand Accent Palette (R254 G220 B125) */
export const fsColorAccentYellow30 = "hsl(44, 98%, 74%)";
/** Brand Accent Palette (R251 G212 B77) */
export const fsColorAccentYellow40 = "hsl(47, 96%, 64%)";
/** Brand Accent Palette (R249 G198 B6) */
export const fsColorAccentYellow50 = "hsl(47, 95%, 50%)";
/** Brand Accent Palette (R241 G186 B13) */
export const fsColorAccentYellow60 = "hsl(46, 90%, 50%)";
/** Brand Accent Palette (R232 G173 B17) */
export const fsColorAccentYellow70 = "hsl(44, 86%, 49%)";
/** Gravity Visited Links Only */
export const fsColorRebeccaPurple = "hsl(270, 50%, 40%)";
/** Used for the default state of primary interactive elements. */
export const fsColorInteractivePrimaryDefault = "hsl(200, 98%, 35%)";
/** Used for the hover state of primary interactive elements. */
export const fsColorInteractivePrimaryHover = "hsl(200, 97%, 30%)";
/** Used for the focus state of primary interactive elements. */
export const fsColorInteractivePrimaryFocus = "hsl(200, 97%, 30%)";
/** Used for the active state of primary interactive elements. */
export const fsColorInteractivePrimaryActive = "hsl(200, 98%, 23%)";
/** Used for the default state of secondary interactive elements. */
export const fsColorInteractiveSecondaryDefault = "hsl(0, 0%, 41%)";
/** Used for the hover state of secondary interactive elements. */
export const fsColorInteractiveSecondaryHover = "hsl(0, 0%, 32%)";
/** Used for the focus state of secondary interactive elements. */
export const fsColorInteractiveSecondaryFocus = "hsl(0, 0%, 32%)";
/** Used for the active state of secondary interactive elements. */
export const fsColorInteractiveSecondaryActive = "hsl(0, 0%, 24%)";
/** Used for the default state of high-impact interactive elements. */
export const fsColorInteractiveActionDefault = "hsl(108, 80%, 28%)";
/** Used for the hover state of high-impact interactive elements. */
export const fsColorInteractiveActionHover = "hsl(108, 81%, 23%)";
/** Used for the focus state of high-impact interactive elements. */
export const fsColorInteractiveActionFocus = "hsl(108, 81%, 23%)";
/** Used for the active state of high-impact interactive elements. */
export const fsColorInteractiveActionActive = "hsl(108, 80%, 18%)";
/** Used for the default state of destructive interactive elements. */
export const fsColorInteractiveDestructiveDefault = "hsl(359, 70%, 47%)";
/** Used for the hover state of destructive interactive elements. */
export const fsColorInteractiveDestructiveHover = "hsl(359, 66%, 44%)";
/** Used for the focus state of destructive interactive elements. */
export const fsColorInteractiveDestructiveFocus = "hsl(359, 66%, 44%)";
/** Used for the active state of destructive interactive elements. */
export const fsColorInteractiveDestructiveActive = "hsl(359, 61%, 40%)";
/** Used for the default state of inverted interactive elements on darker backgrounds. */
export const fsColorInteractiveInverseDefault = "hsl(0, 0%, 100%)";
/** Used for the hover state of inverted interactive elements on darker backgrounds. */
export const fsColorInteractiveInverseHover = "hsl(0, 0%, 96%)";
/** Used for the focus state of inverted interactive elements on darker backgrounds. */
export const fsColorInteractiveInverseFocus = "hsl(0, 0%, 96%)";
/** Used for the active state of inverted interactive elements on darker backgrounds. */
export const fsColorInteractiveInverseActive = "hsl(0, 0%, 90%)";
/** Used for high-emphasis disabled interactive elements. */
export const fsColorDisabledDark = "hsl(0, 0%, 49%)";
/** Used for medium-emphasis disabled interactive elements. */
export const fsColorDisabledMedium = "hsl(0, 0%, 83%)";
/** Used for low-emphasis disabled interactive elements. */
export const fsColorDisabledLight = "hsl(0, 0%, 96%)";
/** Used for elements that provide neutral feedback (not info, success, warning or critical). */
export const fsColorFeedbackNeutralPrimary = "hsl(0, 0%, 41%)";
/** Used for accenting neutral elements. */
export const fsColorFeedbackNeutralSecondary = "hsl(0, 0%, 96%)";
/** Used for elements that provide informative feedback (helpful, passive, pending or in progress). */
export const fsColorFeedbackInfoPrimary = "hsl(200, 98%, 35%)";
/** Used for accenting informative elements. */
export const fsColorFeedbackInfoSecondary = "hsl(200, 100%, 97%)";
/** Used for elements that provide positive feedback (success, approved, completion or confirmation). */
export const fsColorFeedbackPositivePrimary = "hsl(108, 80%, 28%)";
/** Used for accenting positive elements. */
export const fsColorFeedbackPositiveSecondary = "hsl(108, 100%, 97%)";
/** Used for elements that provide warning feedback (attention or caution). */
export const fsColorFeedbackWarningPrimary = "hsl(47, 95%, 50%)";
/** Used for accenting warning elements. */
export const fsColorFeedbackWarningSecondary = "hsl(40, 100%, 97%)";
/** Used for elements that provide critical feedback (error, danger, negative, rejected, urgent or high importance). */
export const fsColorFeedbackCriticalPrimary = "hsl(359, 70%, 47%)";
/** Used for accenting critical elements. */
export const fsColorFeedbackCriticalSecondary = "hsl(0, 100%, 97%)";
/** Used for the primary focus indicator outline on lighter backgrounds. */
export const fsColorFocusPrimaryDefault = "hsl(200, 98%, 35%)";
/** Used for the primary focus indicator outline on darker backgrounds or on photos. */
export const fsColorFocusPrimaryHighContrast = "hsl(0, 0%, 100%)";
/** Used for the secondary focus indicator outline on lighter backgrounds. */
export const fsColorFocusSecondaryDefault = "hsl(0, 0%, 100%)";
/** Used for the secondary focus indicator outline on darker backgrounds or on photos. */
export const fsColorFocusSecondaryHighContrast = "hsl(0, 0%, 8%)";
/** Full font stack for web */
export const fsFontStack = "Optimist, \"Helvetica Neue\", Helvetica, Arial, sans-serif";
/** Used for the base font family. */
export const fsFontFamily = "Optimist";
/** Used for light font weight. */
export const fsFontWeightLight = 300;
/** Used for semibold font weight. */
export const fsFontWeightSemibold = 600;
/** Used for extra light font weight. */
export const fsFontWeightExtraLight = 100;
/** Used for base regular font weight. */
export const fsFontWeightRegular = 400;
/** Used for 1x base line height. */
export const fsFontLineHeightBase = 1;
/** Used for 1.2x of base line height. */
export const fsFontLineHeightTiny = 1.2;
/** Used for 1.3x of base line height. */
export const fsFontLineHeightSmall = 1.3;
/** Used for 1.5x of base line height. */
export const fsFontLineHeightNormal = 1.5;
/** Used for 1.7x of base line height. */
export const fsFontLineHeightMedium = 1.7;
/** Used for 1x base font size. */
export const fsFontSizeBase = "1rem";
/** Used for 0.75x of base font size. */
export const fsFontSizeSmall1 = "0.75rem";
/** Used for 0.875x of base font size. */
export const fsFontSizeSmall2 = "0.875rem";
/** Used for 1x of base font size. */
export const fsFontSizeMedium1 = "1rem";
/** Used for 1.25x of base font size. */
export const fsFontSizeMedium2 = "1.25rem";
/** Used for 1.5x of base font size. */
export const fsFontSizeMedium3 = "1.5rem";
/** Used for 2x of base font size. */
export const fsFontSizeLarge1 = "2rem";
/** Used for 2.5x of base font size. */
export const fsFontSizeLarge2 = "2.5rem";
/** Used for 3x of base font size. */
export const fsFontSizeLarge3 = "3rem";
/** Used for 4x of base font size. */
export const fsFontSizeXlarge1 = "4rem";
/** Used for tiny headlines. */
export const fsFontHeadingTiny = "0.75rem";
/** Used for small headlines. */
export const fsFontHeadingSmall = "0.875rem";
/** Used for normal headlines. */
export const fsFontHeadingNormal = "1rem";
/** Used for medium headlines. */
export const fsFontHeadingMedium = "1.25rem";
/** Used for large headlines. */
export const fsFontHeadingLarge = "2rem";
/** Used for xlarge headlines. */
export const fsFontHeadingXlarge = "3rem";
/** Used for xxlarge headlines. */
export const fsFontHeadingXxlarge = "4rem";
/** Used for tiny body text. */
export const fsFontBodyTiny = "0.75rem";
/** Used for small body text. */
export const fsFontBodySmall = "0.875rem";
/** Used for normal body text. */
export const fsFontBodyNormal = "1rem";
/** Used for medium body text. */
export const fsFontBodyMedium = "1.25rem";
/** Used for tiny overline style section headlines. */
export const fsFontOverlineTiny = "0.75rem";
/** Used for small overline style section headlines. */
export const fsFontOverlineSmall = "0.875rem";
/** Used for normal overline style section headlines. */
export const fsFontOverlineNormal = "1rem";
/** Used for tiny tabular numeral style text. */
export const fsFontTabularNumeralsTiny = "0.75rem";
/** Used for small tabular numeral style text. */
export const fsFontTabularNumeralsSmall = "0.875rem";
/** Used for a small amount of grid columns. */
export const fsGridColumnsSmall = 4;
/** Used for a medium amount of grid columns. */
export const fsGridColumnsMedium = 8;
/** Used for a large amount of grid columns. */
export const fsGridColumnsLarge = 12;
/** Used for small sized grid gutters. */
export const fsGridGutterSmall = "1rem";
/** Used for large sized grid gutters. */
export const fsGridGutterLarge = "2rem";
/** Used for small sized grid margins. */
export const fsGridMarginSmall = "1rem";
/** Used for medium sized grid margins. */
export const fsGridMarginMedium = "1rem";
/** Used for large sized grid margins. */
export const fsGridMarginLarge = "3rem";
/** Used for 0x of base spacing unit. */
export const fsSizeSpacingNone = 0;
/** Used for 0.125x of base spacing unit. */
export const fsSizeSpacingTiny1 = "1px";
/** Used for 0.25x of base spacing unit. */
export const fsSizeSpacingTiny2 = "2px";
/** Used for 0.5x of base spacing unit. */
export const fsSizeSpacingTiny3 = "4px";
/** Used for 0.75x of base spacing unit. */
export const fsSizeSpacingTiny4 = "6px";
/** Used for 1x base spacing unit. */
export const fsSizeSpacingSmall1 = "8px";
/** Used for 1.5x of base spacing unit. */
export const fsSizeSpacingSmall2 = "12px";
/** Used for 2x of base spacing unit. */
export const fsSizeSpacingMedium1 = "16px";
/** Used for 3x of base spacing unit. */
export const fsSizeSpacingMedium2 = "24px";
/** Used for 4x of base spacing unit. */
export const fsSizeSpacingLarge1 = "32px";
/** Used for 5x of base spacing unit. */
export const fsSizeSpacingLarge2 = "40px";
/** Used for 6x of base spacing unit. */
export const fsSizeSpacingLarge3 = "48px";
/** Used for 7x of base spacing unit. */
export const fsSizeSpacingLarge4 = "56px";
/** Used for 8x of base spacing unit. */
export const fsSizeSpacingXlarge1 = "64px";
/** Used for 9x of base spacing unit. */
export const fsSizeSpacingXlarge2 = "72px";
/** Used for 10x of base spacing unit. */
export const fsSizeSpacingXlarge3 = "80px";
/** Used for 11x of base spacing unit. */
export const fsSizeSpacingXlarge4 = "88px";
/** Used for 12x of base spacing unit. */
export const fsSizeSpacingXlarge5 = "96px";
/** Used for 0x of base size. */
export const fsSizeNone = "0px";
/** Used for 0.125x of base size. */
export const fsSizeTiny1 = "1px";
/** Used for 0.25x of base size. */
export const fsSizeTiny2 = "2px";
/** Used for 0.5x of base size. */
export const fsSizeTiny3 = "4px";
/** Used for 0.75x of base size. */
export const fsSizeTiny4 = "6px";
/** Used for 1x base size. */
export const fsSizeSmall1 = "8px";
/** Used for 1.5x of base size. */
export const fsSizeSmall2 = "12px";
/** Used for 2x of base size. */
export const fsSizeMedium1 = "16px";
/** Used for 3x of base size. */
export const fsSizeMedium2 = "24px";
/** Used for 4x of base size. */
export const fsSizeLarge1 = "32px";
/** Used for 5x of base size. */
export const fsSizeLarge2 = "40px";
/** Used for 6x of base size. */
export const fsSizeLarge3 = "48px";
/** Used for 7x of base size. */
export const fsSizeLarge4 = "56px";
/** Used for 8x of base size. */
export const fsSizeXlarge1 = "64px";
/** Used for 9x of base size. */
export const fsSizeXlarge2 = "72px";
/** Used for 10x of base size. */
export const fsSizeXlarge3 = "80px";
/** Used for 11x of base size. */
export const fsSizeXlarge4 = "88px";
/** Used for 12x of base size. */
export const fsSizeXlarge5 = "96px";
/** Used for placing an element at the lowest level on the z-axis. */
export const fsZIndexDeep = -9999;
/** Used for placing an element at the default level on the z-axis. */
export const fsZIndexDefault = 1;
/** Used for placing a sticky element above lower level elments on the z-axis. */
export const fsZIndexSticky = 100;
/** Used for placing a modal element above lower level elments on the z-axis. */
export const fsZIndexModal = 800;
/** Used for placing an element at the highest level on the z-axis. */
export const fsZIndexTop = 900;
/** Best used for animations that are purposeful or exiting. */
export const fsAnimationDuration1 = "0.1s";
/** Best used for animations that are purposeful or entering. */
export const fsAnimationDuration2 = "0.2s";
/** Best used for animations that are purposeful, expressive or entering. */
export const fsAnimationDuration3 = "0.3s";
/** Best used for animations that are expressive, entering or moving. */
export const fsAnimationDuration4 = "0.4s";
/** Best used for animations that are expressive or moving. */
export const fsAnimationDuration5 = "0.5s";
/** The standard curve slowly accelerates at it starts, speeds up, and then gradually decelerates as it comes to a stop. This is the standard default easing curve to use for most general motion. */
export const fsAnimationEasingPurposefulStandard = "cubic-bezier(0.30, 0.00, 0.00, 1.00)";
/** undefined */
export const fsAnimationEasingPurposefulEntrance = "cubic-bezier(0.17, 0.17, 0.20, 1.00)";
/** The Exit Curve slowly accelerates and continues to speeds up before quickly slowing as it comes to a stop. This curve is great for objects exiting from focus, they acceclerate quickly out of view or back to a default value, drawing minimal attention as they go. */
export const fsAnimationEasingPurposefulExit = "cubic-bezier(1.00, 0.01, 0.65, 0.70)";
/** The standard curve slowly accelerates at it starts, speeds up, and then gradually decelerates as it comes to a stop. This is the standard default easing curve to use for most general motion. */
export const fsAnimationEasingExpressiveStandard = "cubic-bezier(0.94, 0.03, 0.03, 1.13)";
/** The entrance curve accelerates quickly from the start and then gradually decelerates as it comes to a stop. This curve is great for objects entering into focus, they come in quickly but ease to a stop, drawing attention to them. */
export const fsAnimationEasingExpressiveEntrance = "cubic-bezier(0.14, 0.68, 0.19, 1.11)";
/** The Exit Curve slowly accelerates and continues to speeds up before quickly slowing as it comes to a stop. This curve is great for objects exiting from focus, they acceclerate quickly out of view or back to a default value, drawing minimal attention as they go. */
export const fsAnimationEasingExpressiveExit = "cubic-bezier(1.00, -0.28, 0.81, 0.76)";
/** Used for applying a 4:3 aspect ratio to an element's width and height. */
export const fsAspectRatio4X3 = 1.3333333333;
/** Used for applying a 3:2 aspect ratio to an element's width and height. */
export const fsAspectRatio3X2 = 1.5;
/** Used for applying a 16:9 aspect ratio to an element's width and height. */
export const fsAspectRatio16X9 = 1.7777777778;
/** Used for applying a 2:1 aspect ratio to an element's width and height. */
export const fsAspectRatio2X1 = 2;
/** Used for applying a 2:3 aspect ratio to an element's width and height. */
export const fsAspectRatio2X3 = 0.6666666667;
/** Used for applying a 3:4 aspect ratio to an element's width and height. */
export const fsAspectRatio3X4 = 0.75;
/** Used for applying a 1:1 aspect ratio to an element's width and height. */
export const fsAspectRatio1X1 = 1;
/** Used for 0x of base radius for rounding the corners of an element. */
export const fsRadiusNone = "0px";
/** Used for 0.25x of base radius for rounding the corners of an element. */
export const fsRadiusTiny = "2px";
/** Used for 0.5x of base radius for rounding the corners of an element. */
export const fsRadiusSmall = "4px";
/** Used for .75x base radius for rounding the corners of an element. */
export const fsRadiusMedium = "6px";
/** Used for 1x base radius for rounding the corners of an element. */
export const fsRadiusLarge = "8px";
/** Used for 1.5x base radius for rounding the corners of an element. */
export const fsRadiusXLarge = "12px";
/** Used for rounding the corners of an element into a pill shape. */
export const fsRadiusPill = "100vh";
/** Used for rounding the corners of an element into a circle shape. */
export const fsRadiusCircle = "50%";
/** Used for a border with 0x of the base weight to an element. */
export const fsBorderNone = "none";
/** Used for a border with 1x of the base weight to an element. */
export const fsBorderSolidThin = "1px solid";
/** Used for a border with 2x of the base weight to an element. */
export const fsBorderSolidMedium = "2px solid";
/** Used for a border with 4x of the base weight to an element. */
export const fsBorderSolidThick = "4px solid";
/** Used for a dashed border at a 1x base weight to an element. */
export const fsBorderDashedThin = "1px dashed";
/** Used for a dashed border with 2x of the base weight to an element. */
export const fsBorderDashedMedium = "2px dashed";
/** Used for max width breakpoint of extra small viewports on web. */
export const fsBreakpointExtraSmall = "23rem";
/** Used for min width breakpoint of small viewports on web. */
export const fsBreakpointSmall = "23.0625rem";
/** Used for min width breakpoint of medium viewports on web. */
export const fsBreakpointMedium = "37.5rem";
/** Used for min width breakpoint of medium large viewports on web. */
export const fsBreakpointMediumLarge = "48rem";
/** Used for min width breakpoint of large viewports on web. */
export const fsBreakpointLarge = "64rem";
/** Used for min width breakpoint of extra large viewports on web. */
export const fsBreakpointExtraLarge = "75rem";
/** Used for min width breakpoint of large display viewports on web. */
export const fsBreakpointLargeDisplay = "120rem";
/** Used for max width to constrain content to a fixed size in larger viewports on web. */
export const fsBreakpointMaxWidth = "76rem";
/** Used for high-emphasis static text. */
export const fsTextColorPrimary = "hsl(0, 0%, 8%)";
/** Used for medium-emphasis static text. */
export const fsTextColorSecondary = "hsl(0, 0%, 41%)";
/** Used for inverted static text on darker backgrounds. */
export const fsTextColorInverse = "hsl(0, 0%, 100%)";
/** Used for disabled interactive text. */
export const fsTextColorDisabled = "hsl(0, 0%, 49%)";
/** Used for the default state of primary text links. */
export const fsTextColorLinkPrimaryDefault = "hsl(200, 98%, 35%)";
/** Used for the hover state of primary text links. */
export const fsTextColorLinkPrimaryHover = "hsl(200, 97%, 30%)";
/** Used for the focus state of primary text links. */
export const fsTextColorLinkPrimaryFocus = "hsl(200, 97%, 30%)";
/** Used for the active state of primary text links. */
export const fsTextColorLinkPrimaryActive = "hsl(200, 98%, 23%)";
/** Used for the visited state of primary text links. */
export const fsTextColorLinkPrimaryVisited = "hsl(270, 50%, 40%)";
/** Used for the default state of secondary text links. */
export const fsTextColorLinkSecondaryDefault = "hsl(0, 0%, 41%)";
/** Used for the hover state of secondary text links. */
export const fsTextColorLinkSecondaryHover = "hsl(0, 0%, 32%)";
/** Used for the focus state of secondary text links. */
export const fsTextColorLinkSecondaryFocus = "hsl(0, 0%, 32%)";
/** Used for the active state of secondary text links. */
export const fsTextColorLinkSecondaryActive = "hsl(0, 0%, 24%)";
/** Used for the visited state of secondary text links. */
export const fsTextColorLinkSecondaryVisited = "hsl(270, 50%, 40%)";
/** Used for the default state of inverted text links on darker backgrounds. */
export const fsTextColorLinkInverseDefault = "hsl(0, 0%, 100%)";
/** Used for the hover state of inverted text links on darker backgrounds. */
export const fsTextColorLinkInverseHover = "hsl(0, 0%, 96%)";
/** Used for the focus state of inverted text links on darker backgrounds. */
export const fsTextColorLinkInverseFocus = "hsl(0, 0%, 96%)";
/** Used for the active state of inverted text links on darker backgrounds. */
export const fsTextColorLinkInverseActive = "hsl(0, 0%, 90%)";
/** Used for the visited state of inverted text links on darker backgrounds. */
export const fsTextColorLinkInverseVisited = "hsl(0, 0%, 100%)";
/** Used for text that provides positive feedback (success, approved, completion or confirmation). */
export const fsTextColorLinkFeedbackPositive = "hsl(108, 80%, 28%)";
/** Used for text that provides critical feedback (error, danger, negative, rejected, urgent or high importance). */
export const fsTextColorLinkFeedbackNegative = "hsl(359, 70%, 47%)";
/** Used for high-emphasis static icons. */
export const fsIconColorPrimary = "hsl(0, 0%, 8%)";
/** Used for medium-emphasis static icons. */
export const fsIconColorSecondary = "hsl(0, 0%, 41%)";
/** Used for inverted static icons on darker backgrounds. */
export const fsIconColorInverse = "hsl(0, 0%, 100%)";
/** Used for disabled interactive icons. */
export const fsIconColorDisabled = "hsl(0, 0%, 49%)";
/** Used for the default state of primary interactive icons. */
export const fsIconColorInteractivePrimaryDefault = "hsl(200, 98%, 35%)";
/** Used for the hover state of primary interactive icons. */
export const fsIconColorInteractivePrimaryHover = "hsl(200, 97%, 30%)";
/** Used for the focus state of primary interactive icons. */
export const fsIconColorInteractivePrimaryFocus = "hsl(200, 97%, 30%)";
/** Used for the active state of primary interactive icons. */
export const fsIconColorInteractivePrimaryActive = "hsl(200, 98%, 23%)";
/** Used for the default state of secondary interactive icons. */
export const fsIconColorInteractiveSecondaryDefault = "hsl(0, 0%, 41%)";
/** Used for the hover state of secondary interactive icons. */
export const fsIconColorInteractiveSecondaryHover = "hsl(0, 0%, 32%)";
/** Used for the focus state of secondary interactive icons. */
export const fsIconColorInteractiveSecondaryFocus = "hsl(0, 0%, 32%)";
/** Used for the active state of secondary interactive icons. */
export const fsIconColorInteractiveSecondaryActive = "hsl(0, 0%, 24%)";
/** Used for the default state of secondary destructive icons. */
export const fsIconColorInteractiveDestructiveDefault = "hsl(359, 70%, 47%)";
/** Used for the hover state of secondary destructive icons. */
export const fsIconColorInteractiveDestructiveHover = "hsl(359, 66%, 44%)";
/** Used for the focus state of secondary destructive icons. */
export const fsIconColorInteractiveDestructiveFocus = "hsl(359, 66%, 44%)";
/** Used for the active state of secondary destructive icons. */
export const fsIconColorInteractiveDestructiveActive = "hsl(359, 61%, 40%)";
/** Used for the default state of inverted interactive icons on darker backgrounds. */
export const fsIconColorInteractiveInverseDefault = "hsl(0, 0%, 100%)";
/** Used for the hover state of inverted interactive icons on darker backgrounds. */
export const fsIconColorInteractiveInverseHover = "hsl(0, 0%, 96%)";
/** Used for the focus state of inverted interactive icons on darker backgrounds. */
export const fsIconColorInteractiveInverseFocus = "hsl(0, 0%, 96%)";
/** Used for the active state of inverted interactive icons on darker backgrounds. */
export const fsIconColorInteractiveInverseActive = "hsl(0, 0%, 90%)";
/** Used for icons that provide informative feedback (helpful, passive, pending or in progress). */
export const fsIconColorFeedbackInfo = "hsl(200, 98%, 35%)";
/** Used for icons that provide positive feedback (success, approved, completion or confirmation). */
export const fsIconColorFeedbackPositive = "hsl(108, 80%, 28%)";
/** Used for icons that provide positive feedback (success, approved, completion or confirmation). */
export const fsIconColorFeedbackWarning = "hsl(47, 95%, 50%)";
/** Used for icons that provide critical feedback (error, danger, negative, rejected, urgent or high importance). */
export const fsIconColorFeedbackCritical = "hsl(359, 70%, 47%)";
/** Used for the default state of backgrounds on form elements. */
export const fsFormColorBackgroundDefault = "hsl(0, 0%, 100%)";
/** Used for the disabled state of backgrounds on form elements. */
export const fsFormColorBackgroundDisabled = "hsl(0, 0%, 96%)";
/** Used for the default state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedDefault = "hsl(200, 98%, 35%)";
/** Used for the hover state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedHover = "hsl(200, 97%, 30%)";
/** Used for the focus state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedFocus = "hsl(200, 97%, 30%)";
/** Used for the active state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedActive = "hsl(200, 98%, 23%)";
/** Used for the error state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedError = "hsl(359, 70%, 47%)";
/** Used for the disabled state of backgrounds on checked form elements. */
export const fsFormColorBackgroundCheckedDisabled = "hsl(0, 0%, 83%)";
/** Used for the default state of borders on form elements. */
export const fsFormColorBorderDefault = "hsl(0, 0%, 41%)";
/** Used for the hover state of borders on form elements. */
export const fsFormColorBorderHover = "hsl(200, 98%, 35%)";
/** Used for the default state of borders on form elements. */
export const fsFormColorBorderFocus = "hsl(200, 98%, 35%)";
/** Used for the active state of borders on form elements. */
export const fsFormColorBorderActive = "hsl(200, 98%, 23%)";
/** Used for the error state of borders on form elements. */
export const fsFormColorBorderError = "hsl(359, 70%, 47%)";
/** Used for the disabled state of borders on form elements. */
export const fsFormColorBorderDisabled = "hsl(0, 0%, 83%)";
/** Used for the default state of text labels on form elements. */
export const fsFormTextColorLabelDefault = "hsl(0, 0%, 8%)";
/** Used for the disabled state of text labels on form elements. */
export const fsFormTextColorLabelDisabled = "hsl(0, 0%, 49%)";
/** Used for the default state of input text on form elements. */
export const fsFormTextColorInputDefault = "hsl(0, 0%, 8%)";
/** Used for the placeholder state of input text on form elements. */
export const fsFormTextColorInputPlaceholder = "hsl(0, 0%, 49%)";
/** Used for the disabled state of input text on form elements. */
export const fsFormTextColorInputDisabled = "hsl(0, 0%, 49%)";
/** Used for helper text on form elements. */
export const fsFormTextColorHelperDefault = "hsl(0, 0%, 41%)";
/** Used for the error state of helper text on form elements. */
export const fsFormTextColorHelperError = "hsl(359, 70%, 47%)";
/** Used for the error state of helper text on form elements. */
export const fsFormTextColorHelperDisabled = "hsl(0, 0%, 49%)";
/** Used for the default state of helper text links on form elements. */
export const fsFormTextColorHelperLinkDefault = "hsl(200, 98%, 35%)";
/** Used for the hover state of helper text links on form elements. */
export const fsFormTextColorHelperLinkHover = "hsl(200, 97%, 30%)";
/** Used for the focus state of helper text links on form elements. */
export const fsFormTextColorHelperLinkFocus = "hsl(200, 97%, 30%)";
/** Used for the active state of helper text links on form elements. */
export const fsFormTextColorHelperLinkActive = "hsl(200, 98%, 23%)";
/** Used for masking content with a dark overlay at 10% opacity. */
export const fsOverlayDark10 = "rgba(20, 20, 20, 0.1)";
/** Used for masking content with a dark overlay at 25% opacity. */
export const fsOverlayDark25 = "rgba(20, 20, 20, 0.25)";
/** Used for masking content with a dark overlay at 50% opacity. */
export const fsOverlayDark50 = "rgba(20, 20, 20, 0.5)";
/** Used for masking content with a dark overlay at 90% opacity. */
export const fsOverlayDark90 = "rgba(20, 20, 20, 0.9)";
/** Used for masking content with a light overlay at 10% opacity. */
export const fsOverlayLight10 = "rgba(255, 255, 255, 0.1)";
/** Used for masking content with a light overlay at 25% opacity. */
export const fsOverlayLight25 = "rgba(255, 255, 255, 0.25)";
/** Used for masking content with a light overlay at 50% opacity. */
export const fsOverlayLight50 = "rgba(255, 255, 255, 0.5)";
/** Used for masking content with a light overlay at 90% opacity. */
export const fsOverlayLight90 = "rgba(255, 255, 255, 0.9)";
/** Used for the default border color of data table rows and cells. */
export const fsDataTableColorBorderDefault = "hsl(0, 0%, 83%)";
/** Used for the emphasized border color of data table rows and cells. */
export const fsDataTableColorBorderEmphasized = "hsl(0, 0%, 41%)";
/** Used for the default state of a light themed header cell. */
export const fsDataTableHeaderCellColorBackgroundLightDefault = "hsl(0, 0%, 96%)";
/** Used for the hover state of a light themed header cell. */
export const fsDataTableHeaderCellColorBackgroundLightHover = "hsl(0, 0%, 90%)";
/** Used for the focus state of a light themed header cell. */
export const fsDataTableHeaderCellColorBackgroundLightFocus = "hsl(0, 0%, 90%)";
/** Used for the active state of a light themed header cell. */
export const fsDataTableHeaderCellColorBackgroundLightActive = "hsl(0, 0%, 83%)";
/** Used for the disabled state of a light themed header cell. */
export const fsDataTableHeaderCellColorBackgroundLightDisabled = "hsl(0, 0%, 96%)";
/** Used for the default state of a white themed header cell. */
export const fsDataTableHeaderCellColorBackgroundWhiteDefault = "hsl(0, 0%, 100%)";
/** Used for the hover state of a white themed header cell. */
export const fsDataTableHeaderCellColorBackgroundWhiteHover = "hsl(0, 0%, 96%)";
/** Used for the focus state of a white themed header cell. */
export const fsDataTableHeaderCellColorBackgroundWhiteFocus = "hsl(0, 0%, 96%)";
/** Used for the active state of a white themed header cell. */
export const fsDataTableHeaderCellColorBackgroundWhiteActive = "hsl(0, 0%, 90%)";
/** Used for the disabled state of a white themed header cell. */
export const fsDataTableHeaderCellColorBackgroundWhiteDisabled = "hsl(0, 0%, 100%)";
/** Used for the default state of a data table row. */
export const fsDataTableRowColorBackgroundDefault = "transparent";
/** Used for the hover state of a data table row. */
export const fsDataTableRowColorBackgroundHover = "#fbfbfb";
/** Used for the selected state of a data table row. */
export const fsDataTableRowColorBackgroundSelected = "#F7FCFF";
/** Used for the selected hover state of a data table row. */
export const fsDataTableRowColorBackgroundSelectedHover = "#F3F8FB";
/** Used for the default state of a data table row that is highlighted with a zebra stripe. */
export const fsDataTableRowColorBackgroundZebraStripeDefault = "#FBFBFB";
/** Used for the hover state of a data table row that is highlighted with a zebra stripe. */
export const fsDataTableRowColorBackgroundZebraStripeHover = "#F7F7F7";
/** Used for the selected state of a data table row that is highlighted with a zebra stripe. */
export const fsDataTableRowColorBackgroundZebraStripeSelected = "#F3F9FB";
/** Used for the selected hover state of a data table row that is highlighted with a zebra stripe. */
export const fsDataTableRowColorBackgroundZebraStripeSelectedHover = "#EFF5F7";
/** Used for elements that have low elevation along the z-axis. */
export const fsShadowElevationLevel1 = "0 1px 4px rgba(0, 0, 0, 0.2)";
/** Used for elements that have medium elevation along the z-axis. */
export const fsShadowElevationLevel2 = "0 2px 8px rgba(0, 0, 0, 0.2)";
/** Used for elements that have high elevation along the z-axis. */
export const fsShadowElevationLevel3 = "0 4px 16px rgba(0, 0, 0, 0.2)";